export default __webpack_public_path__ + "static/char-v-17-d760d8432755e28df020e7db997aec58.mp4";